import apiClient from '../apiClient';
import { GET_MENU_CLASS_URL } from '../apiUrl';

const getMenuClassesApi = () => {
  return apiClient.get(GET_MENU_CLASS_URL);
};

export default getMenuClassesApi;
